import React from 'react';

class AdvisoryContent extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      data: [
        {
          img: 'So_Huu_Tri_Tue.svg',
          title: 'Tư vấn sở hữu trí tuệ',
          phone: '0905 881 089',
          skype: 'khanh.vov',
          zalo: 'Contact.zalo'
        },
        {
          img: 'Tu_Van_Phap_Ly_Doanh_Nghiep.svg',
          title: 'Tư vấn pháp lý doanh nghiệp',
          phone: '0913 334 469',
          skype: 'khanh.vov',
          zalo: 'Contact.zalo'
        },
        {
          img: 'Tu_Van_Phap_Ly_San_Pham.svg',
          title: 'Tư vấn pháp lý sản phẩm',
          phone: '0905 881 089',
          skype: 'khanh.vov',
          zalo: 'Contact.zalo'
        },
        {
          img: 'Xay_Dung_Website.svg',
          title: 'Tư vấn xây dựng website',
          phone: '0905 637 283',
          skype: 'van.kovo',
          zalo: 'Contact.zalo'
        },
        {
          img: 'Thiet_Ke_Bao_Bi.svg',
          title: 'Tư vấn thiết kế bao bì',
          phone: '',
          skype: 'khanh.vov',
          zalo: 'Contact.zalo'
        },
        {
          img: 'Marketing_Online.svg',
          title: 'Tư vấn xây dựng hệ thống marketing online cơ bản',
          phone: '0167 447 8370',
          skype: 'thuyhong8588',
          zalo: 'Contact.zalo'
        }
      ]
    };
  }

  render() {
    return (
      <section className="advisory-content-wrap">
        {
          this.state.data.map((item, idx) => {
            return (
              <div className="block-advisory">
                <img className="advisory-img" src={require(`assets/images/advisory/${item.img}`)}/>
                <div className="advisory-content">
                  <span className="title">{item.title}</span>
                  <span className="phone"><a href={`tel:84${item.phone.replace(/ /g, '')}`}>{item.phone}</a></span>
                  <span className="skype"><a href={`skype:${item.skype}?chat`}>{item.skype}</a></span>
                  {/*<span className="zalo">{item.zalo}</span>*/}
                </div>
              </div>
            );
          })
        }
      </section>
    );
  }
}

export default AdvisoryContent;



// WEBPACK FOOTER //
// ./components/users/sub-view/advisory-content/AdvisoryContent.jsx